module.exports = __webpack_public_path__ + "img/front_L.34881dd9.svg";